/**
 * external libs
 */
import React from 'react'
import {useTranslation} from "react-i18next";
/**
 * enums
 */
import ResultKeysEnum from "../../../../../enums/api/ResultKeys";
/**
 * utils
 */
import calculateAge from "../../../../../utils/calculateAge";
import getWidget from "../../../../../utils/getWidget";
import {Tooltip} from "antd";
import DateTime from "../../../../../utils/DateTime";


export default function WidgetAge({ birthDayResult, deathDayResult }){
    const {t} = useTranslation()
    const birthDayDate = new Date(birthDayResult?.measures?.datetime || birthDayResult?.measures)
    const deathDayDate = new Date(deathDayResult?.measures?.datetime || deathDayResult?.measures)

    if(!birthDayResult || !birthDayResult.measures){
        return null;
    }

    return (
        <Tooltip placement="top" title={DateTime.toLocaleDate(birthDayDate)}>
            {calculateAge(birthDayDate, deathDayResult ? deathDayDate : null)}
        </Tooltip>
    )
}
